module.exports = __webpack_public_path__ + "media/images/menu/forms-1c59d709da70d3140a07e3827de11a08.svg";